export default __webpack_public_path__ + "static/bg-mobile-2d8828bafa83ebf0250d9deb4ea09842.png";